<template>
  <div class="slide contentarea">
    <p>{{data.ruby}}</p>
    <p>{{data.title}}</p>
    <div>{{data.subtitle}}</div>
    <slick 
      ref="slick"
      :options="slickOptions">
      <div v-for="path in data.slide"><img class="object-fit-img" :src="path" alt=""></div>
    </slick>
    <div class="t_left slide_detail">{{data.text}}</div>
  </div>
</template>

<style lang="less">
  //mediaquery設定
  @screen-xs-max: 660px; //スマホ
  @screen-sm-max: 768px; //ipad
  @screen-lg-max: 1200px; //ブラウザサイズ1200px以下
  .screen-xs(@rules) {
      @media (max-width: @screen-xs-max) { @rules(); } 
  }
  .screen-sm(@rules) {
      @media (max-width: @screen-sm-max) { @rules(); }
  }
  .screen-lg(@rules) {
      @media (max-width: @screen-lg-max) { @rules(); }
  }

  @import '../../node_modules/slick-carousel/slick/slick.css';

  .slide {
    padding-top: 100px !important;
    p{
      &:first-child{
        font-size: 20px;
        .screen-xs({
          font-size: 16px;
        });
      }
      &:last-of-type{
        font-size: 38px;
        .screen-xs({
          font-size: 28px;
        });
      }
    }
    .slick-slide img{
      margin: 50px auto 0;
      width: 100%;
      height: 660px;
      object-fit: contain;
      font-family: 'object-fit: contain;';
      .screen-lg({
        height: 750px;
      });
      .screen-sm({
        height: 550px;
      });
      .screen-xs({
        height: 250px;
      });
    }
    .slick-arrow{
      position: absolute;
      top: 37%;
      z-index: 100;
      padding: 4px 8px;
      background: none;
      border: none;
      cursor: pointer;
      outline: none;
    }
    .slick-prev{
      left: 10px;
      .slide_txt{
        color: #BFBFBF;
        font-size: 18px;
      }
      .screen-xs({
        left: 0;
        img{
          width: 70%;
        }
      });
    }
    .slick-next{
      right: 10px;
      .slide_txt{
        color: #BFBFBF;
        font-size: 18px;
      }
      .screen-xs({
        right: 0;
        img{
          width: 70%;
        }
      });
    }
    .slick-dots{
      margin: 0;
      padding: 10px 0 50px;
      .slick-active{
        img{
          opacity: .6;
        }
      }
      li{
        margin-left: 1.875%;
        width: 18.5%;
        display: inline-block;
        img{
          width: 100%;
          height: 170px;
          cursor: pointer;
          transition: .2s ease-in-out;
          object-fit: cover;
          font-family: 'object-fit: cover;';
          .screen-sm({
            height: 120px;
          });
          .screen-xs({
            height: 60px;
          });
        }
        &:hover{
          img{
            opacity: .6;
          }
        }
        &:first-child{
          margin-left: 0;
        }
      }
    }
    .slide_detail{
      margin-bottom: 100px;
      .screen-sm({
        margin-bottom: 50px;
      });
    }
  }
</style>

<script>
  import Slick from "vue-slick"
  import $ from "jquery"

  export default {
    name: 'Slide',
    props: {
      data: Object
    },
    components: {Slick},
    data() {
      return {
        slickOptions: {
          dots: true,
          lazyLoad: 'ondemand',
          // スライド下のサムネイル表示
          customPaging: function(slider, i) {
            const thumbSrc = $(slider.$slides[i]).find("img").attr("src")
            return '<img src="' + thumbSrc + '">'
          },
          prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><img src="image/prev.png" alt="Previous"><p class="slide_txt">Prev</p></button>',
          nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><img src="image/next.png" alt="Next"><p class="slide_txt">Next</p></button>',
        }
      }
    },
    beforeUpdate() {
      // slick適用後はデータ更新がうまくいかないので更新前に解除
      if (this.$refs.slick) {
        this.$refs.slick.destroy()
      }
    },
    updated() {
      this.reInit()
    },
    methods: {
      reInit() {
        // データ更新後にslick適用
        this.$nextTick(() => {
          this.$refs.slick.create()
        });
      }
    }
  }
</script>